import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Heading3 from '../titles/Heading3';
import { Link } from 'react-router-dom';
import VisibilitySensor from 'react-visibility-sensor';

var activeElementStyle = {
  color: '#000',
};

class AsideElement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['']
        };
        this.headerVisible = this.headerVisible.bind(this);
    } 
    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeInUp');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes});
                }.bind(this), timeDelay);
            }
        }
    };   
    render() {
        const props = this.props;
        return (
            <div className="blog-aside">
                <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                    <div>
                        <div className={"gtco-contact-info"+this.state.animationClasses.join(' ') } style={ { opacity : 0 } }>
                            <Heading3 title= { props.recentPosts }/>
                        </div>
                        <div className={"entries"+this.state.animationClasses.join(' ') } style={ { opacity : 0 } }>
                            {props.content.map ((value, index) => 
                                <Link className={ this.state.class } key={index.toString()} to={"article#"+ value.link_to_article }>
                                    {props.activeElement === value.title ? <span style={activeElementStyle}>{props.translate(value.title)}</span> : <span>{props.translate(value.title)}</span>}
                                </Link>
                            )}
                        </div>
                    </div>
                </VisibilitySensor>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(AsideElement);



// WEBPACK FOOTER //
// ./src/components/aside/aside.jsx